import { newPostFunction, newPatchFunction, newDeleteFunction } from '@src/service/lib/types'
import {
  OrganizationUrlProps,
  SyncConfigUrlProps,
  googleDriveConnectUrl,
  googleDriveConnectionUrl,
  googleDriveSyncConfigUrl,
  googleDriveSyncConfigIdUrl,
  googleDriveSyncUrl,
  googleDriveResolveUrl,
  googleDriveLinkUrl,
  googleDriveImportUrl
} from './urls'
import {
  GoogleDriveConnectRequest,
  GoogleDriveSyncConfigCreateRequest,
  GoogleDriveSyncConfigUpdateRequest,
  GoogleDriveTriggerSyncRequest,
  GoogleDriveResolveUrlRequest,
  GoogleDriveLinkCreateRequest,
  GoogleDriveImportRequest
} from './requests'
import {
  GoogleDriveConnectResponse,
  GoogleDriveDisconnectResponse,
  GoogleDriveSyncConfigCreateResponse,
  GoogleDriveSyncConfigUpdateResponse,
  GoogleDriveSyncConfigDeleteResponse,
  GoogleDriveTriggerSyncResponse,
  GoogleDriveResolveUrlResponse,
  GoogleDriveLinkCreateResponse,
  GoogleDriveImportResponse
} from './responses'

export const connectGoogleDrive = newPostFunction<OrganizationUrlProps, GoogleDriveConnectRequest, GoogleDriveConnectResponse>(googleDriveConnectUrl)
export const disconnectGoogleDrive = newDeleteFunction<OrganizationUrlProps, GoogleDriveDisconnectResponse>(googleDriveConnectionUrl)
export const createSyncConfiguration = newPostFunction<OrganizationUrlProps, GoogleDriveSyncConfigCreateRequest, GoogleDriveSyncConfigCreateResponse>(googleDriveSyncConfigUrl)
export const updateSyncConfiguration = newPatchFunction<SyncConfigUrlProps, GoogleDriveSyncConfigUpdateRequest, GoogleDriveSyncConfigUpdateResponse>(googleDriveSyncConfigIdUrl)
export const deleteSyncConfiguration = newDeleteFunction<SyncConfigUrlProps, GoogleDriveSyncConfigDeleteResponse>(googleDriveSyncConfigIdUrl)
export const triggerSync = newPostFunction<OrganizationUrlProps, GoogleDriveTriggerSyncRequest, GoogleDriveTriggerSyncResponse>(googleDriveSyncUrl)
export const resolveGoogleDriveUrl = newPostFunction<OrganizationUrlProps, GoogleDriveResolveUrlRequest, GoogleDriveResolveUrlResponse>(googleDriveResolveUrl)
export const linkGoogleDriveItems = newPostFunction<OrganizationUrlProps, GoogleDriveLinkCreateRequest, GoogleDriveLinkCreateResponse>(googleDriveLinkUrl)
export const importGoogleDriveItems = newPostFunction<OrganizationUrlProps, GoogleDriveImportRequest, GoogleDriveImportResponse>(googleDriveImportUrl)
